// extracted by mini-css-extract-plugin
export default {"root":"CoursePauseRequestApproveModalSuccessStage_root__SRz8z","approved":"CoursePauseRequestApproveModalSuccessStage_approved__BszoM"};